import getDisplayInformation from './get-display-information';

const getIsBeta = (idBag) => {
  const displayInformation = getDisplayInformation(idBag);
  return displayInformation?.beta;
};

export default getIsBeta;
